import { ref } from '@vue/composition-api'
import { campaignsUseCase } from '../../usecases'


const useCampaigns = () => {
    const data = ref([])
    const getData = async (type, uid) => {
        if(type === 'publish') {
            data.value = await campaignsUseCase.getPublished(uid)
        }
        if(type === 'drafts') {
            data.value = await campaignsUseCase.getDrafts(uid)
        }
        if(type === 'archives') {
            data.value = await campaignsUseCase.getArchives(uid)
        }
        if(type === 'favorite') {
            data.value = await campaignsUseCase.getFavorites(uid)
        }
    }

    const archiveData = async (campData) => {
        const response = await campaignsUseCase.archiveCampaign(campData)
        if(response) {
            data.value = data.value.filter(item => item.id !== campData.id)
            return 'archived'
        }
    }
    const restoreCampaign = async (campData) => {
        const restored = await campaignsUseCase.restoreCampaign(campData)
        if(restored){
            data.value = data.value.filter(item => item.id !== campData.id)
        }
    }
    const favoriteCampaigns = async (campData, uid) => {
        await campaignsUseCase.removeFromFavorite(campData, uid)
        data.value = data.value.filter(item => item.id !== campData.id)
    }
    return {
        data,
        getData,
        archiveData,
        restoreCampaign,
        favoriteCampaigns
    }
}

export default useCampaigns